// initial state
const state = {
    orderDetail: {}
  };
  
  // getters
  const getters = {};
  
  // actions
  const actions = {};
  
  // mutations
  const mutations = {
    setOrderDetail(state, orderDetail) {
      //设置参数
      state.orderDetail = orderDetail;
    }
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
  


// WEBPACK FOOTER //
// ./src/store/module/orderDetail.js